import React from 'react';
import { Frame, Type } from '../../../src/components/code';
import { BR, I, II, III } from '../utils';

const description = `As a good practice, we will also add means of 
unsubscribing from the state changes.`;

export default () => (
  <Frame description={description}>
    {`export class Store {${BR}`}
    {`${I}constructor(reducers, initialState = {}) {${BR}`}
    {`${II}this._state = initialState; // "Private"${BR}`}
    {`${II}this.reducers = reducers;${BR}`}
    {`${II}this.observers = [];`}
    {`${I}}${BR}`}
    {`${BR}`}
    {`${I}dispatch(action) {${BR}`}
    {`${II}let newState = { ...this.state };${BR}`}
    {`${II}for (const name in this.reducers) {${BR}`}
    {`${III}const reducer = this.reducers[name];${BR}`}
    {`${III}const slice = this.state[name];${BR}`}
    {`${III}newState[name] = reducer(slice, action);`}
    {`${II}}${BR}`}
    {`${II}this.state = newState;`}
    {`${I}}${BR}`}
    {BR}
    {`${I}subscribe(observer) {${BR}`}
    {`${II}this.observers.push(observer);`}
    <Type>
      {`${II}return () => {${BR}`}
      {`${III}this.observers = this.observers.filter(fn => fn !== observer);${BR}`}
      {`${II}};`}
    </Type>
    {`${I}}`}
    {'}'}
    {BR}
    {`const initialState = {};${BR}`}
    {`export const store = new Store(initialState);${BR}`}
  </Frame>
);
